import { getAuthorizationHeader } from '../sgwt/sgwtConnect.ts'
import { type HealthDto } from '@/models/health.ts'
import { getConfig } from '@/config/config.ts';
import type { PingdomCreationDto } from '@/models/pingdom.ts';


export class HealthService {
  get(search: string): Promise<HealthDto> {

    const { apiUrl } = getConfig();
    const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: getAuthorizationHeader(),
        },
      } as RequestInit;

    const encoded = encodeURIComponent(search);

    return fetch(`${apiUrl}/api/v2/healths/${encoded}`, requestOptions)
    .then((_response: Response) => {
        if( _response.ok)
        {
          try {
            return _response.json();
          }
          catch (error) {
              return { status: "Healthy"};
          }

        }
        else {
          if (_response.status == 404)
            throw new Error('Url not found (404)');
          else if (_response.status == 200)
            return {status: "Healthy"}
          else
            throw new Error('Healthcheck is not in a recognized json format:'+encoded);
        }
    })
    .catch((reason: any) => {
      if ((reason+"").indexOf("SyntaxError: Failed to execute 'json' on 'Response': Unexpected end of JSON input") >= 0)
        return { status: "Healthy" };
      throw reason;
    });
  }
  
  addToPingdom(webAppKey: string): Promise<PingdomCreationDto> {

    const { apiUrl } = getConfig();
    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: getAuthorizationHeader(),
        },
      } as RequestInit;

    const encoded = encodeURIComponent(webAppKey);

    return fetch(`${apiUrl}/api/v2/healths/${encoded}/pingdom`, requestOptions)
    .then((_response: Response) => {
        if( _response.ok)
        {
          try {
            return _response.json();
          }
          catch (error) {
              return { status: error};
          }

        }
        else {
            throw new Error('WebApp cannot be added to Pingdom:'+encoded);
        }
    })
    .catch((reason: any) => {
      if ((reason+"").indexOf("SyntaxError: Failed to execute 'json' on 'Response': Unexpected end of JSON input") >= 0)
        return { status: "An error occurs" };
      throw reason;
    });
  }
}